import type { Days, Seconds } from "../types.ts";

export const computeDateDifference = (
  firstDate: Date,
  secondDate: Date,
): Seconds => (secondDate.getTime() - firstDate.getTime()) / 1000;

export const computeDaysUntilDate = (futureDate: number): Days =>
  Math.round((futureDate - Date.now()) / (1000 * 60 * 60 * 24));

export const formatDate = (date: string) => {
  const d = new Date(date);
  return d.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
